/**
 * BillBulkIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BillBulkIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M20.22 3.778a9.5 9.5 0 0 0-13.436.01 9.4 9.4 0 0 0-1.316 1.68 9 9 0 0 0-1.68 1.314 9.49 9.49 0 0 0 0 13.44c3.707 3.704 9.728 3.704 13.445 0a9.2 9.2 0 0 0 1.335-1.71 9.2 9.2 0 0 0 1.652-1.296c3.707-3.705 3.707-9.714 0-13.429zm-3.054 13.688-.125.202c-.298.47-.644.921-1.047 1.324-3.044 3.034-7.971 3.034-11.006 0a7.767 7.767 0 0 1 0-11c.461-.461.97-.855 1.517-1.171 2.978-1.767 6.906-1.383 9.47 1.18s2.948 6.48 1.172 9.465zm2.718-2.553a9.5 9.5 0 0 0-.337-4.31v-.01a8 8 0 0 0-.393-1.017v-.01a10 10 0 0 0-.51-.97.2.2 0 0 0-.038-.057 11 11 0 0 0-.547-.797c-.048-.057-.087-.115-.135-.173a9 9 0 0 0-.7-.787s-.02-.01-.03-.019c-.23-.23-.48-.441-.73-.653a3 3 0 0 0-.278-.21 6 6 0 0 0-.576-.394c-.096-.058-.192-.125-.288-.183q-.39-.227-.778-.413c-.135-.067-.279-.124-.423-.182l-.451-.173c-.163-.057-.317-.115-.48-.163-.135-.038-.27-.067-.413-.106a10 10 0 0 0-.922-.182c-.116-.02-.221-.029-.336-.048a12 12 0 0 0-.586-.048h-.288c-.413 0-.826.01-1.24.058-.038 0-.076 0-.114.01-.077.009-.164.009-.24.019a7.78 7.78 0 0 1 9.93.883 7.78 7.78 0 0 1 .893 9.925z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M9.646 10.046h1.575c.71 0 1.296.586 1.296 1.296 0 .48.385.864.865.864a.86.86 0 0 0 .864-.864c0-1.622-1.287-2.937-2.89-3.014v-.586a.86.86 0 0 0-.865-.864.86.86 0 0 0-.864.864v.576a2.89 2.89 0 0 0-2.872 2.89c0 1.305.884 2.476 2.18 2.793l2.699.672c.509.124.874.585.874 1.123a1.16 1.16 0 0 1-1.162 1.161H9.77c-.71 0-1.297-.585-1.297-1.296a.86.86 0 0 0-.864-.864.86.86 0 0 0-.864.864 3.01 3.01 0 0 0 2.88 3.005v.595c0 .48.385.864.865.864a.86.86 0 0 0 .864-.864v-.576a2.885 2.885 0 0 0 2.881-2.89 2.88 2.88 0 0 0-2.18-2.793l-2.698-.671a1.145 1.145 0 0 1-.865-1.123 1.16 1.16 0 0 1 1.162-1.162z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BillBulkIcon = makeIcon('BillBulkIcon', BillBulkIconSvg)
